export default "__VITE_ASSET__02df8ff4__"